import { SkeletonLoader } from "@pepperstone/pepper-ui-kit";

type TableMobileLoaderProps = {
  cardsToShow?: number;
};

const TableMobileSkeletonLoaderCard = () => (
  <div className="my-2 min-w-full">
    <div className="rounded-b-lg rounded-t-lg border-x border-b border-t px-4 pt-4">
      <div className="flex min-w-full justify-between">
        <div>
          <SkeletonLoader variant="circular" height={6} width={60} />
        </div>
      </div>
      <div className="py-2">
        <SkeletonLoader variant="circular" height={4} width={80} />
      </div>
      <div className="border-t border-border-primary-base pt-2">
        <div className="flex justify-between pb-1 pt-1">
          <div>
            <SkeletonLoader variant="circular" height={6} width={40} />
          </div>
          <div className="text-end">
            <SkeletonLoader variant="circular" height={6} width={40} />
          </div>
        </div>
        <div className="flex justify-between pb-2 pt-1">
          <div>
            <SkeletonLoader variant="circular" height={6} width={40} />
          </div>
          <div className="text-end">
            <SkeletonLoader variant="circular" height={6} width={40} />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export const TableMobileSkeletonLoader = ({
  cardsToShow = 1,
}: TableMobileLoaderProps) => (
  <div className="gap-2" data-testid="table-mobile-skeleton-loader">
    {Array.from({ length: cardsToShow }, (_, i) => (
      <TableMobileSkeletonLoaderCard key={i} />
    ))}
  </div>
);
